import { inject, Injectable, Injector } from '@angular/core';
import { FeaturedProductsService } from '../services/featured-products.service';
import { Observable } from 'rxjs';
import { IFeatureProducts } from '../models/featured-products.models';

@Injectable({
  providedIn: 'root',
})
export class FeaturedProductsFacade {
  private readonly injector: Injector = inject(Injector);
  private pFeaturedProductsService: FeaturedProductsService | undefined;

  public getFeaturedProductsService(): FeaturedProductsService {
    if (!this.pFeaturedProductsService) {
      this.pFeaturedProductsService = this.injector.get(FeaturedProductsService);
    }
    return this.pFeaturedProductsService;
  }

  getFeaturedProducts(featureProductsKey: string): Observable<IFeatureProducts> {
    return this.getFeaturedProductsService().getFeaturedProducts(featureProductsKey);
  }
}
